import script from "./user-form.vue?vue&type=script&setup=true&lang=js"
export * from "./user-form.vue?vue&type=script&setup=true&lang=js"

import "./user-form.vue?vue&type=style&index=0&id=0c96d8be&lang=css"

const __exports__ = script;

export default __exports__